import { colors } from "assets/constants";

import React from "react";
import { Platform, StyleSheet, View } from "react-native";

import Text from "components/Text";
import Button from "components/Button";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

export default function FactorStatusChangerUi(props: {
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
  value?: FactorStatusT;
}) {
  const { value, onNext, onPrev, onSubmit } = props;

  const {
    company: { color },
  } = useRecoilValue(authAtom);

  return (
    <View style={styles.container}>
      <View style={{ ...styles.changerContainer, borderColor: color }}>
        <Button
          onPress={onPrev}
          width={35}
          height={35}
          bgColor={colors.transparent}
          icon={{ name: "chevron-right", size: 25, color }}
        />
        <View
          style={{
            width: 2,
            height: 30,
            borderRadius: 20,
            backgroundColor: color,
          }}
        />
        <View style={styles.titleContainer}>
          <Text color={color} weight="bold" size={"lg"}>
            {value?.title}
          </Text>
        </View>

        <View
          style={{
            width: 2,
            height: 30,
            borderRadius: 20,
            backgroundColor: color,
          }}
        />
        <Button
          onPress={onNext}
          width={35}
          height={35}
          bgColor="transparent"
          icon={{ name: "chevron-left", size: 25, color }}
        />
      </View>
      {Platform.OS === "web" && <View style={{ width: 12 }} />}
      <Button
        onPress={onSubmit}
        width={35}
        height={35}
        bgColor={color}
        style={{ borderRadius: 15 }}
        icon={{ name: "check", size: 25, color: colors.white }}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 5,
    borderRadius: 15,
    alignItems: "center",
    flexDirection: "row-reverse",
    backgroundColor: colors.lightGlass,
  },

  changerContainer: {
    flexDirection: "row-reverse",
    alignItems: "center",
    alignSelf: "center",
    marginRight: 15,
    borderWidth: 0.5,
    borderRadius: 15,
  },

  titleContainer: {
    width: 100,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center",
  },
});
